import React from "react";
import styles from "./index.module.scss";
import { OverlayPanel } from "primereact/overlaypanel";
import FilterModelBody from "./filter-model-body";

interface propsType {
  popRef: React.RefObject<OverlayPanel>;
}

export default function FilterModel({ popRef }: propsType) {
  React.useEffect(() => {
    const handleScroll = () => {
      const inst: any = popRef?.current;
      if (!inst) return;
      try {
        const el = typeof inst.getElement === "function" ? inst.getElement() : inst?.container || inst?.overlay || null;
        if (!el) return;
        if (typeof inst.hide === "function") inst.hide();
      } catch (_) {}
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [popRef]);

  return (
    <OverlayPanel ref={popRef} className={styles.SortModel}>
      <FilterModelBody popRef={popRef} />
    </OverlayPanel>
  );
}
